export default __webpack_public_path__ + "static/media/pixel-hero-right.7371a099.gif";